jQuery(function(){
    var delayRequest = 500;

    window.ppComponents.autocomplete = {
        initialize(elements) {
            elements.each(function () {
                var $this = $(this);

                var suggestionEndpoint = $this.data("endpoint");
                if (!suggestionEndpoint)
                    return;

                var useEmptyTemplate = !$this.is("[data-no-empty-template]");

                var noResultsTranslation = window.ppt.translate('autocomplete.noresults','Kein Suchergebnis');

                var emptyTemplate = `<div class="empty-message">
                        ${noResultsTranslation}
                    </div>`
                if(!useEmptyTemplate)
                    emptyTemplate = '';

                var autosubmit = $this.is("[data-autosubmit]");

                var engine = new Bloodhound({
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    datumTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: suggestionEndpoint,
                        cache: false,
                        wildcard: '%Q%'
                    }
                });

                $this.data("bloodhoundEngine", engine);
                $this.typeahead(null, {
                    name: 'Suchen',
                    display: 'word',
                    source: engine,
                    templates: {
                        empty: emptyTemplate,
                        suggestion: function (data) {
                            if (!data || data.length == 0) {
                                return emptyTemplate;
                            }
                            var word = data.word;
                            var searchQuery = $this.val();
                            word = word.replace(new RegExp(searchQuery, 'gi'), `<strong>$&</strong>`);
                            return `<div>${word} <i>(${data.count})</i></div>`
                        }
                    }
                });

                //**********a hack******
                $(".twitter-typeahead input").each(function(){
                   var placeholder = $(this).data("placeholder") || "";
                   if(!!placeholder){
                       $(this).attr("aria-label",placeholder);
                   }
                });
                //**********************

                if (!!autosubmit) {
                    $this.bind('typeahead:select', function (ev, suggestion) {
                        $this.closest("form").submit();
                    });
                }

            })
        }
    }

    window.ppComponents.autocomplete.initialize($("input[data-autocomplete]"));


});